import {combineReducers} from 'redux';

import {toasterReducers} from '@homeaway/react-toaster';
import {tripboardButtonReducer} from '@homeaway/react-trip-board-button';

import content from './content';
import destination from './destination';
import familyFriendly from '../modules/FamilyFriendly/redux';
import greatPlaces from './greatPlaces';
import modules from './modules';
import propertyTypes from '../modules/PropertyTypes/redux';
import search from './search';
import seoLinkpile from './seo-linkpile';

function takeNoAction(state) {
    return state || {};
}

export const reducers = combineReducers({
    abacus: takeNoAction,
    config: takeNoAction,
    content,
    destination,
    error: takeNoAction,
    familyFriendly,
    freeCancellation: takeNoAction,
    greatPlaces,
    mab: takeNoAction,
    modules,
    propertyTypes,
    search,
    seoLinkpile,
    siteContext: takeNoAction,
    toaster: toasterReducers,
    tripboardButton: tripboardButtonReducer,
});

export default reducers;
